export const settings = {
  setShareTitle: 'Поділитися додатком',
  setNotifiationsTitle: 'Сповіщення',
  setContactAppOwnerTitle: 'Написати власнику додатку',
  setContactDevelopersTitle: 'Написати розробникам',
  setReportAppTitle: 'Поскаржитися на додаток',
  setDeleteAccountTitle: 'Видалити обліковий запис',
  setLogOutTitle: 'Вийти',
  setShareAppCurtainTitle: 'Поділитися додатком',
  setShareAppCurtainButtonTitle: 'Скопіювати посилання',
  setShareAppAlertWhenAppLinkWasCopied: 'Посилання скопійовано!',
  setNotificationsInAppTitle: 'Внутрішні',
  setNotificationsPushContent: 'Пуш',
  setNotificationsChatsTitle: 'Чати',
  setNotificationsDiscussionsTitle: 'Дискусії',
  setNotificationsNewsTitle: 'Стрічка новин',
  setNotificationsEventsTitle: 'Події',
  setNotificationsAdminTitle: 'Адмінські сповіщення',
  setNotificationsBlogTitle: 'Блоґ',
  setNotificationsPushOffContent: 'Push-нотифікації вимкнено',
  setNotificationsPushOffText:
    'Щоб увімкнути push-сповіщення, перейдіть у налаштування свого пристрою/телефону та увімкніть сповіщення',
  setReportAppFlagCurtainTitle: 'Скарга',
  setAppReportedCurtainContent: 'Скаргу надісланно',
  setDeleteCurtainTitle: 'Видалити обліковий запис',
  setDeleteCurtainInputContent: 'Пароль',
  setDeleteCurtainCancelButtonTitle: 'Скасувати',
  setDeleteCurtainConfirmButtonTitle: 'Підтвердити',
  setDeleteCurtainIncorrectPasswordAlertText: 'Невірний пароль',
  setTurnNotificationsOnText: 'Для того, щоб їх включити, будь ласка, натисніть на кнопку нижче та дозвольте нам надсилати вам сповіщення.',
  setTurnNotificationsOnButton: 'Включити push-нотифікації'
}
